import { render, staticRenderFns } from "./I18nTextField.vue?vue&type=template&id=1f2bf9fe"
import script from "./I18nTextField.vue?vue&type=script&lang=js"
export * from "./I18nTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports